import React from 'react';
import { motion } from 'framer-motion';
import { Github, Star, GitBranch, GitPullRequest, Users, ArrowRight, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const OpenSource: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-32 pb-20 px-8">
      <div className="max-w-7xl mx-auto">
        <motion.button
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.3em] text-[#525252] hover:text-white transition-colors mb-8 group"
        >
          <ArrowLeft className="w-3 h-3 group-hover:-translate-x-1 transition-transform" />
          Back to Overview
        </motion.button>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-20 text-center"
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-500 text-[10px] font-bold uppercase tracking-widest mb-8">
            <Github className="w-3 h-3" />
            OPEN SOURCE FIRST
          </div>
          <h1 className="text-5xl md:text-8xl font-bold tracking-tighter text-white mb-6 uppercase leading-[0.9]">
            BUILT BY THE <br />
            <span className="text-emerald-500">COMMUNITY</span>
          </h1>
          <p className="text-[#525252] font-mono text-lg max-w-2xl mx-auto leading-relaxed">
            Oru Trace is a modular, open-source visual debugger for EVM networks. Join us in building the future of developer infrastructure.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {[
            { label: "Stars", value: "1.2k+", icon: <Star className="w-5 h-5 text-yellow-500" /> },
            { label: "Forks", value: "240+", icon: <GitBranch className="w-5 h-5 text-blue-500" /> },
            { label: "Contributors", value: "45+", icon: <Users className="w-5 h-5 text-purple-500" /> }
          ].map((stat, i) => (
            <div key={i} className="p-8 rounded-3xl bg-[#0F0F0F] border border-[#262626] flex flex-col items-center justify-center text-center">
              <div className="mb-4">{stat.icon}</div>
              <div className="text-4xl font-bold text-white mb-2 tracking-tighter">{stat.value}</div>
              <div className="text-[10px] font-bold uppercase tracking-widest text-[#525252]">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-10 rounded-3xl bg-[#0F0F0F] border border-[#262626] flex flex-col justify-between group hover:border-emerald-500/30 transition-all">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6 uppercase tracking-tighter">Contribution Guide</h3>
              <p className="text-[#525252] font-mono text-sm leading-relaxed mb-8">
                We welcome contributions of all kinds! Whether you're fixing a bug, adding a new feature, or improving documentation, we'd love to have you on board.
              </p>
            </div>
            <a href="#" className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-emerald-500 group-hover:translate-x-2 transition-transform">
              Read the Guide
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
          <div className="p-10 rounded-3xl bg-[#0F0F0F] border border-[#262626] flex flex-col justify-between group hover:border-emerald-500/30 transition-all">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6 uppercase tracking-tighter">Roadmap</h3>
              <p className="text-[#525252] font-mono text-sm leading-relaxed mb-8">
                Check out our public roadmap to see what we're working on and what's coming next for Oru Trace.
              </p>
            </div>
            <a href="#" className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-emerald-500 group-hover:translate-x-2 transition-transform">
              View Roadmap
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-32 p-12 rounded-3xl bg-emerald-500 text-black flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="text-4xl font-bold mb-4 uppercase tracking-tighter leading-none">Ready to contribute?</h2>
            <p className="text-black/70 font-mono text-sm leading-relaxed">
              Join our Telegram community and start building the future of EVM debugging with us.
            </p>
          </div>
          <div className="flex gap-4">
            <a href="https://github.com/Oru-Lab/Oru-Trace" className="bg-black text-white font-bold px-8 py-4 rounded-md transition-all text-xs uppercase tracking-widest flex items-center gap-2">
              <Github className="w-4 h-4" />
              GitHub
            </a>
            <a href="https://t.me/OruLabs" className="bg-white text-black font-bold px-8 py-4 rounded-md transition-all text-xs uppercase tracking-widest">
              Telegram
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
